var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBsChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.96936 2.46888C7.03903 2.39903 7.1218 2.34362 7.21291 2.30581C7.30403 2.268 7.40171 2.24854 7.50036 2.24854C7.59901 2.24854 7.6967 2.268 7.78781 2.30581C7.87893 2.34362 7.9617 2.39903 8.03136 2.46888L17.0314 11.4689C17.1012 11.5385 17.1566 11.6213 17.1944 11.7124C17.2322 11.8035 17.2517 11.9012 17.2517 11.9999C17.2517 12.0985 17.2322 12.1962 17.1944 12.2873C17.1566 12.3784 17.1012 12.4612 17.0314 12.5309L8.03136 21.5309C7.89053 21.6717 7.69953 21.7508 7.50036 21.7508C7.3012 21.7508 7.11019 21.6717 6.96936 21.5309C6.82853 21.39 6.74942 21.199 6.74942 20.9999C6.74942 20.8007 6.82853 20.6097 6.96936 20.4689L15.4399 11.9999L6.96936 3.53088C6.89952 3.46121 6.8441 3.37844 6.80629 3.28733C6.76849 3.19621 6.74902 3.09853 6.74902 2.99988C6.74902 2.90122 6.76849 2.80354 6.80629 2.71243C6.8441 2.62131 6.89952 2.53854 6.96936 2.46888Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBsChevronRight);
export default __webpack_public_path__ + "static/media/bsChevronRight.0a4306da36a48053d2ff6e9be796bf95.svg";
export { ForwardRef as ReactComponent };